import React from 'react';

export type Props = {
  className?: string;
  height?: number;
  width?: number;
};

export const Invoice = React.memo((props: Props) => {
  const {
    width = 16,
    height = 16,
    className,
  } = props;

  const style = {
    minWidth: width,
    minHeight: height,
  };

  return (
    <svg
      width={width}
      height={height}
      className={className}
      style={style}
      viewBox='0 0 28.09 40.02'
    >
      <path d='m12.81,1.16h12.2c1.21,0,2.2.98,2.2,2.2v33.22c0,1.21-.98,2.2-2.2,2.2H2.98c-1.21,0-2.2-.98-2.2-2.2V13.22' fill='#c7017f' strokeWidth='0px' /><path d='m12.81,1.16v9.34c0,1.51-1.22,2.73-2.73,2.73H.78L12.81,1.16Z' fill='#821269' strokeWidth='0px' /><rect x='5.68' y='17.27' width='16.47' height='1.92' rx='.94' ry='.94' fill='#fff' strokeWidth='0px' /><path d='m21.22,19.26H6.62c-.55,0-1-.45-1-1v-.04c0-.55.45-1,1-1h14.59c.55,0,1,.45,1,1h0v.04c0,.55-.45,1-1,1h.01Zm-14.59-1.92c-.49,0-.88.39-.88.88h0v.04c0,.49.4.88.88.88h14.59c.48,0,.87-.4.87-.88v-.04c0-.49-.39-.88-.88-.88H6.62h0Z' fill='#fff' strokeWidth='0px' /><rect x='5.68' y='24.15' width='16.47' height='1.92' rx='.94' ry='.94' fill='#fff' strokeWidth='0px'/><path d='m21.22,26.14H6.62c-.55,0-1-.45-1-1h0v-.04c0-.55.45-1,1-1h14.59c.55,0,1,.45,1,1v.04c0,.55-.45,1-1,1h.01Zm-14.59-1.92c-.49,0-.88.39-.88.88v.04c0,.49.39.88.88.88h14.59c.48,0,.87-.4.87-.88v-.04c0-.49-.39-.88-.88-.88H6.62h0Z' fill='#fff' strokeWidth='0px' /><rect x='5.68' y='31.03' width='16.47' height='1.92' rx='.94' ry='.94' fill='#fff' strokeWidth='0px' /><path d='m21.22,33.01H6.62c-.55,0-1-.45-1-1h0v-.04c0-.55.45-1,1-1h14.59c.55,0,1,.45,1,1h0v.04c0,.55-.45,1-1,1h.01Zm-14.59-1.92c-.49,0-.88.39-.88.88v.04c0,.49.39.88.88.88h14.59c.48,0,.87-.4.87-.88v-.04c0-.49-.39-.88-.88-.88H6.62h0Z' fill='#fff' strokeWidth='0px' />
    </svg>
  );
});

Invoice.displayName = 'Invoice';
